import ReviewsHome from "@/views/reviews/ReviewsHome.vue";
import ReviewsDailyAssignmentsView from "@/views/reviews/ReviewsDailyAssignmentsView.vue";
import ReviewsClassic from "@/views/reviews/ReviewsClassic.vue";
import ReviewsImport from "@/views/reviews/ReviewsImport.vue";
import ReviewsHomePage from "@/views/reviews/ReviewsHomePage.vue";

const routes = [
  {
    path: "/reviews",
    name: "ReviewsLanding",
    component: ReviewsHomePage,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews/today",
    name: "ReviewsToday",
    component: ReviewsDailyAssignmentsView,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    // Keep old path as alias so bookmarks/links still work
    path: "/reviews-home",
    name: "ReviewsHome",
    component: ReviewsDailyAssignmentsView,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-classic",
    name: "ReviewsClassic",
    component: ReviewsClassic,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-import",
    name: "ReviewsImport",
    component: ReviewsImport,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews/platform/:platform/location/:location",
    name: "ReviewsByPlatformLocation",
    component: ReviewsClassic,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/reviews-calendar",
    name: "ReviewsCalendar",
    component: ReviewsHome,
    meta: { feature: "reviews", requiresAuth: true, app: "reviews" },
  },
  {
    path: "/review-assignments",
    name: "ReviewAssignments",
    component: () => import("@/views/settings/ReviewAssignments.vue"),
    meta: { feature: "reviews", requiresAuth: true, requiresAdmin: true, app: "reviews" },
  },
];

export default routes;
